// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuotes";

/**
 * Xng-Change
 * Parse islistingPage for all load quotes requests if current page is quote list page
 * @param props 
 */
export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const islistingPage = getCurrentPage(props.getState()).type === "RfqMyQuotesPage";
    props.apiParameter = {
        ...props.parameter,
        islistingPage,
    } as any;
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
